import React from 'react'
import FabricEditor from '../../Components/FabricEditor/FabricEditor'

function FabricEditorPage() {
  return (
    <div>
        <FabricEditor/>
    </div>
  )
}

export default FabricEditorPage